import { render, staticRenderFns } from "./BrainstormScoreItem.vue?vue&type=template&id=d56569d2&scoped=true&"
import script from "./BrainstormScoreItem.vue?vue&type=script&lang=js&"
export * from "./BrainstormScoreItem.vue?vue&type=script&lang=js&"
import style0 from "./BrainstormScoreItem.vue?vue&type=style&index=0&id=d56569d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56569d2",
  null
  
)

export default component.exports